var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('base-spinner'),(_vm.showLayout)?[_c('TopBar'),_c('div',{staticClass:"d-flex flex-row w-100 app-body"},[_c('layout-navigation'),_c('div',{staticClass:"app-main-content"},[_c('router-view')],1)],1)]:_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }